import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-gradient-to-br from-amber-50 via-orange-50 to-amber-100 border-t border-amber-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <h3 className="text-2xl font-bold text-gray-900">
              VIP Luxury Cars <span className="text-amber-600">MKS</span>
            </h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              Alquiler de autos de lujo premium en Cancún y Miami. Experimenta la emoción de conducir los vehículos más exclusivos del mundo.
            </p>
            <div className="flex items-center gap-2 text-sm text-gray-700">
              <i className="ri-map-pin-line text-amber-600"></i>
              <strong>Ubicaciones</strong>
            </div>
            <div className="space-y-2 text-sm text-gray-600 pl-6">
              <div>
                <p className="font-medium text-gray-700">📍 Cancún, México</p>
                <p className="text-xs leading-relaxed">Blvd. Kukulcan Km 16.4<br />Zona Hotelera, 77500</p>
              </div>
              <p>📍 Miami, Florida, USA</p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold text-gray-900 mb-4">
              Enlaces Rápidos
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-gray-600 hover:text-amber-600 transition-colors text-sm"
                >
                  Inicio
                </Link>
              </li>
              <li>
                <Link
                  to="/fleet"
                  className="text-gray-600 hover:text-amber-600 transition-colors text-sm"
                >
                  Flota
                </Link>
              </li>
              <li>
                <Link
                  to="/wedding-packages"
                  className="text-gray-600 hover:text-amber-600 transition-colors text-sm"
                >
                  Bodas
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-gray-600 hover:text-amber-600 transition-colors text-sm"
                >
                  Nosotros
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-gray-600 hover:text-amber-600 transition-colors text-sm"
                >
                  Contacto
                </Link>
              </li>
              <li>
                <Link
                  to="/policies"
                  className="text-gray-600 hover:text-amber-600 transition-colors text-sm"
                >
                  Políticas
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold text-gray-900 mb-4">
              Contacto
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <i className="ri-phone-line text-amber-600 mt-1 w-5 h-5 flex items-center justify-center"></i>
                <div>
                  <p className="text-xs text-gray-500">Teléfono</p>
                  <a
                    href="tel:+522291578562"
                    className="text-sm text-gray-700 hover:text-amber-600 transition-colors"
                  >
                    +52 229 157 8562
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-amber-600 mt-1 w-5 h-5 flex items-center justify-center"></i>
                <div>
                  <p className="text-xs text-gray-500">Correo</p>
                  <a
                    href="mailto:info@vipluxurycarsmks.com"
                    className="text-sm text-gray-700 hover:text-amber-600 transition-colors break-all"
                  >
                    info@vipluxurycarsmks.com
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-whatsapp-line text-amber-600 mt-1 w-5 h-5 flex items-center justify-center"></i>
                <div>
                  <p className="text-xs text-gray-500">WhatsApp</p>
                  <a
                    href="https://wa.me/522291578562"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-gray-700 hover:text-amber-600 transition-colors"
                  >
                    +52 229 157 8562
                  </a>
                </div>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h4 className="text-lg font-semibold text-gray-900 mb-4">
              Síguenos
            </h4>
            <div className="flex gap-3">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white rounded-full text-gray-600 hover:text-white hover:bg-amber-600 transition-all shadow-sm hover:shadow-md"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white rounded-full text-gray-600 hover:text-white hover:bg-amber-600 transition-all shadow-sm hover:shadow-md"
                aria-label="Instagram"
              >
                <i className="ri-instagram-fill text-lg"></i>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white rounded-full text-gray-600 hover:text-white hover:bg-amber-600 transition-all shadow-sm hover:shadow-md"
                aria-label="Twitter"
              >
                <i className="ri-twitter-x-fill text-lg"></i>
              </a>
            </div>
            <div className="mt-6 space-y-2">
              <p className="text-xs text-gray-500 font-medium">Marcas Premium:</p>
              <p className="text-xs text-gray-600 leading-relaxed">
                Ferrari | Lamborghini | McLaren | Porsche | Mercedes-Benz | Land Rover
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-amber-200">
          <div className="flex flex-col md:flex-row justify-center items-center gap-4">
            <p className="text-sm text-gray-600">
              © {new Date().getFullYear()} VIP Luxury Cars MKS. Todos los derechos reservados.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
